(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oxiclear-facelift-shell"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeDrawerState = () => {
      if (!document.body || document.body.dataset.ocDrawerStateReady === 'true') return;
      document.body.dataset.ocDrawerStateReady = 'true';

      const synchronizeDrawerState = () => {
        const isOpen = document.body.classList.contains('js-drawer-open-left');
        document.querySelectorAll('[aria-controls="NavDrawer"]').forEach((control) => {
          control.setAttribute('aria-expanded', String(isOpen));
        });
      };

      new MutationObserver(synchronizeDrawerState).observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
      });
      document.addEventListener('shopify:section:load', synchronizeDrawerState);
      synchronizeDrawerState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeDrawerState, { once: true });
    } else {
      initializeDrawerState();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
